import React from "react";
import ListGroup from "react-bootstrap/ListGroup";
import BootstrapTable from "react-bootstrap-table-next";
import Table from "react-bootstrap/Table";

import Calculations from "../service/Calculations";
//import Badge from "react-bootstrap/Badge";

//https://medium.com/geekculture/react-bootstrap-table-820099053df0

export default function PoemsDataComponent(props) {
  const poems = props.poems;
  const withoutMessage = props.withoutMessage;
  let titles = [];
  if (poems === null) {
    if (withoutMessage === true) {
      return <div></div>;
    } else {
      return (
        <div>
          <ListGroup.Item variant="primary">Ожидайте...</ListGroup.Item>
        </div>
      );
    }
  }

  if (poems.length > 0) {
    for (let index = 0; index < poems.length; index++) {
      titles.push(
        "[" +
          poems[index].id_verse +
          "] " +
          poems[index].poem_title +
          ". " +
          poems[index].meter_group +
          ". " +
          poems[index].poem_date +
          " " +
          poems[index].poem_info +
          " " +
          poems[index].translate_from +
          "\n " +
          poems[index].dedicated_to +
          "\n " +
          poems[index].epigraph
      );
    }
  }

  const summaryData = Calculations.bildStressProfilesForPoems(poems);
  const numberOfLines = summaryData.get("numberLines");
  const numberOfPoems = summaryData.get("numberPoems");
  const poemsProfiles = summaryData.get("poemsProfiles");
  const stressProfileAll = summaryData.get("stressProfileAll");

  const columns = [
    {
      dataField: "row_key",
      text: "Номер строки",
      sort: true,
    },
    {
      dataField: "line",
      text: "Строка",
      sort: false,
    },
    {
      dataField: "representation",
      text: "Представление",
    },
    {
      dataField: "meter_group",
      text: "Размер",
    },
    {
      dataField: "number_of_tonic_feet",
      text: "Число стоп",
    },
    {
      dataField: "irregularity_on_syllable",
      text: "Нерегулярность на слоге",
    },
  ];

  return (
    <div>
      <ListGroup.Item variant="primary">
        Результат: {numberOfPoems} стихотворений, {numberOfLines} стихотворных
        строк. Нумерация строк терпит разрывы на границах строф.
      </ListGroup.Item>
      {titles.map((breakpoint, idx) => (
        <ListGroup
          horizontal={breakpoint}
          className="poem_titles"
          key={"poem_titles" + idx}
        >
          <ListGroup.Item variant="dark">{breakpoint}</ListGroup.Item>

          <BootstrapTable
            bootstrap4
            keyField="row_key"
            data={poems[idx].linesOfPoemList}
            columns={columns}
          />
          <ListGroup.Item variant="warning">
            Профиль ударности стихотворных строк
            <Table responsive>
              <thead>
                <tr>
                  <th>Номер слога</th>
                  {poemsProfiles[idx].map((_, index) => (
                    <th key={index}>{index + 1}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Процент ударности</td>
                  {poemsProfiles[idx].map((_, index) => (
                    <td key={index}>{poemsProfiles[idx][index]}</td>
                  ))}
                </tr>
              </tbody>
            </Table>
          </ListGroup.Item>
        </ListGroup>
      ))}
      <ListGroup className="poem_titles" key={"all_poems_profile"}>
        <ListGroup.Item variant="primary">
          Профиль ударности по всему результату запроса:
          <Table responsive>
            <thead>
              <tr>
                <th>Номер слога</th>
                {stressProfileAll.map((_, index) => (
                  <th key={index}>{index + 1}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Процент ударности</td>
                {stressProfileAll.map((_, index) => (
                  <td key={index}>{stressProfileAll[index]}</td>
                ))}
              </tr>
            </tbody>
          </Table>
        </ListGroup.Item>
      </ListGroup>
    </div>
  );
}
